import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

const ADDITIONAL_EQUIPMENT_SUM_LIST = [
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.0', value: '0' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.20', value: '20000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.30', value: '30000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.40', value: '40000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.50', value: '50000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.60', value: '60000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.70', value: '70000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.80', value: '80000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.90', value: '90000' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.100', value: '100000' },
];

export const TRACTOR = {
  nickname: 'PRODUCTS.TRACTOR.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_TYVERI' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
        ]
      }
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      TRACTOR: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO' },
    {
      name: 'vehicleDailyUsage', key: 'VEHICLE_DAILY_USAGE_MOBILE_HOME', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_DAILY_USAGE.USED_OUTSIDE_HOUSEHOLD', value: 'USED_OUTSIDE_HOUSEHOLD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_DAILY_USAGE.NOT_USED_OUTSIDE_HOUSEHOLD', value: 'NOT_USED_OUTSIDE_HOUSEHOLD' },
        ]
      }
    },
    {
      name: 'tractorUsageArea', key: 'VEHICLE_USAGE_AREA_TRACTOR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_USAGE_AREA.USED_IN_FOREST', value: 'USED_IN_FOREST' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_USAGE_AREA.NOT_USED_IN_FOREST', value: 'NOT_USED_IN_FOREST' },
        ]
      }
    },
    {
      name: 'vehicleCommercialUse', key: 'VEHICLE_COMMERCIAL_USE_TRACTOR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleAlarm', key: 'VEHICLE_ALARM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleType', key: 'TRACTOR_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.TRACTOR_UNDER_400_KG', value: 'TRACTOR_UNDER_400_KG' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.TRACTOR_OWN_USE', value: 'TRACTOR_OWN_USE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.TRACTOR_PAID_WORK', value: 'TRACTOR_PAID_WORK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.COMBINE_HARVESTER', value: 'COMBINE_HARVESTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRACTOR_TYPE.ATV', value: 'ATV' },
        ]
      }
    },
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      SNOWMOBILE_SUM_INSURED_RANGE: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.min(0),
        Validators.max(400000)
      ]]
    },
    {
      name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleMortage', key: 'VEHICLE_MORTAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
    { name: 'tffVehicleTaxCode', key: 'TFF_VEHICLE_TAX_CODE', group: 'OBJECT_INFO' },
    { name: 'ofvFirstTimeRegYear', key: 'OFV_FIRST_TIME_REG_YEAR', group: 'OBJECT_INFO' },
    { name: 'tffVehicleChassisNumber', key: 'TFF_VEHICLE_CHASSIS_NUMBER', group: 'OBJECT_INFO' },
    {
      name: 'includeExtendedSumFixedEquipment', key: 'INCLUDE_EXTENDED_SUM_FIXED_EQUIPMENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isIncludeExtendedSumFixedEquipmentCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'contentsSumInsured', key: 'ADDITIONAL_EQUIPMENT', group: 'INSURANCE_INFO',
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: ADDITIONAL_EQUIPMENT_SUM_LIST
      }
    },
  ],
  icon: 'tractor'
};
